import styled from '@emotion/styled';
import type { MaterialSymbolOptions } from 'storybookConfig/mixins/materialSymbol';
import materialSymbol from 'storybookConfig/mixins/materialSymbol';
import Button, { ButtonSizes } from 'storybookConfig/stories/molecules/Button';

/* `small` and `large` are the button's sizes (32px and 44px); the icon follows them, as on the
   other buttons. Any other value is the icon's own size. */
const iconSizeFor = (size?: string) => {
  if (size === ButtonSizes.Small) return '16px';
  if (size === ButtonSizes.Large) return '20px';
  return size;
};

type IconButtonProps = MaterialSymbolOptions & {
  /**
   * The icon is drawn in CSS and the button has no text, so this is its only accessible name.
   */
  'aria-label': string;
};

/**
 * Composes an icon as a button.
 */
const IconButton = styled(Button, {
  shouldForwardProp: (prop) => !['additionalStyling'].includes(prop),
})<IconButtonProps>`
  ${(options) => materialSymbol({ ...options, size: iconSizeFor(options.size) })};
`;

export default IconButton;
